import { TextStyle_TextAlignment } from 'ricos-schema';

const indentLevelToClassName = {
  0: "indentZero",
  1: "indentOne",
  2: "indentTwo",
  3: "indentThree",
  4: "indentFour",
  5: "indentFive",
  6: "indentSix"
};
const TO_DIR = {
  [TextStyle_TextAlignment.LEFT]: "ltr",
  [TextStyle_TextAlignment.RIGHT]: "rtl"
};

export { TO_DIR, indentLevelToClassName };
//# sourceMappingURL=consts.js.map
